import CloseIcon from '@mui/icons-material/Close';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  InputLabel,
  Autocomplete,
  Modal,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useContext, useEffect, useState } from 'react';
import { AWS_CONFIG_TYPE, S3_BUCKET_NAME, AZURE_BLOB_STORAGE } from '../../../BaseUrl';
import { WorkflowContext } from '../../../contexts/WorkflowProvider';
import InputField from '../../../reusable-component/InputField';
import LoadingIcon from '../../../reusable-component/LoadingIcon';
import { BUCKET_NAME } from '../../../constants/Constant';
import generateAlias from '../../../utils/generateAlias';
import { getCsvData2, getSecretsList, testADLSSecretConnection } from "../../../api's/ConnectorsApi";

const styleLoading = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const NodeModal_WriteAzure = ({ open, handleClose, nodeId, nodeName, nodes, edges, changeNodeName, setNodes }) => {
  const { workflow } = useContext(WorkflowContext);

  const domain_name = workflow.engagement.client.depDomainEntity.domain_name;
  const client_name = workflow.engagement.client.client_name;
  const engagement_name = workflow.engagement.engagement_name;
  const workflow_name = workflow.workflow_name;

  const output_path = `${
    AWS_CONFIG_TYPE ? `dep-develop` : 'dep-develop'
  }/${client_name}/${engagement_name}/${workflow_name}/Output/${generateAlias(nodeName, nodeId)}`;

  const output_path_secret = `${client_name}/${engagement_name}/${workflow_name}/Output/${generateAlias(
    nodeName,
    nodeId
  )}`;

  const INITIALSTATE = {
    path: '',
    format: 'csv',
    connection_type: '',
    secret_name: '',
    alias: generateAlias(nodeName, nodeId),
    snowflake_mode: '',
    snowflake_db_table: '',
    persist: false,
    persist_type: '',
    mode: 'overwrite',
    partition: false,
    df: '',
    p_key: '',
    index: '',
    database: '',
    tablename: '',
    // db_type: 'read_csv_aws',
    schema: '',
    distinct_rows: false,
    stream_interval: '',
    sample_view: true,
  };

  const RowLevelOperation = {
    ignoreblanklines: false,
    skipheaders: false,
    columnshift: false,
    junkrecords: false,
    linebreak: false,
    delimiter: ',',
  };

  const { enqueueSnackbar } = useSnackbar();
  const [formField, setFormField] = useState(INITIALSTATE);

  const [disableForm, setDisableForm] = useState(false);
  const [tableName, setTableName] = useState([]);
  const [toggleType, setToggleType] = useState('');
  const [headerName, setHeaderName] = useState([]);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);
  const [errors, setErrors] = useState({ stream_interval: '' });
  const [prevNodeName, setPrevNodeName] = useState('');
  const [flowbuilderRowLevelOperation, setflowbuilderRowLevelOperation] = useState(RowLevelOperation);

  const [connectionType, setConnectionType] = useState('');
  const [secretsList, setSecretsList] = useState([]);
  const [selectedSecret, setSelectedSecret] = useState('');

  const [refreshModalOpen, setRefreshModalOpen] = useState(false);
  const handleRefreshModalOpen = () => setRefreshModalOpen(true);
  const handleRefreshModalClose = () => setRefreshModalOpen(false);

  const bucketValue = AWS_CONFIG_TYPE
    ? `s3://${BUCKET_NAME}`
    : `https://${AZURE_BLOB_STORAGE}.blob.core.windows.net/dep-develop/`;

  const pathOptions = [
    {
      label: 'File Path',
      value: 'filepath',
    },
  ];

  const handleHeaderChange = (obj) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === obj.header;
    });

    if (selectedIndex === -1 && obj.checked) {
      setHeaderName([...headerName, obj]);

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              header: obj.header,
              alias: obj.alias,
              checked: true,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && obj.checked) {
      setHeaderName((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && !obj.checked) {
      setHeaderName((current) =>
        current.filter((object) => {
          return object.header !== obj.header;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              checked: false,
              alias: '',
              cast_datatype: 'string',
              attribute_type: 'static',
              default_value: '',
            };
          }

          return object;
        })
      );
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = fetchedHeader.map((n) => {
        const all = {
          header: n.header,
          alias: n.alias,
          checked: true,
          cast_datatype: 'string',
          attribute_type: 'static',
          default_value: '',
        };
        return all;
      });
      setHeaderName(newSelecteds);
      return;
    }
    setHeaderName([]);
  };

  const isSelected = (name) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === name;
    });

    return selectedIndex !== -1;
  };

  const store = JSON.parse(sessionStorage.getItem('allNodes'));

  const getLocalData = () => {
    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            setPrevNodeName(node.step_name);
          }
        });
      });

      setFormField({ ...formField, df: prev_alias });

      const isHeader = header.some((item) => item.header);
      if (isHeader) {
        const newArr = [];

        if (prevNodeName === 'Join') {
          header.forEach((el) => {
            const exist = el.header.split('.').length;

            if (exist === 2) {
              const head = el.header.split('.')[1];
              newArr.push({ ...el, header: el.alias ? el.alias : head });
            }
          });
        }
        if (newArr.length > 0) {
          header = newArr;
        }

        const uniqueHeader = [];

        const uniqueArray = header.filter((element) => {
          const isDuplicate = uniqueHeader.includes(element.header);

          if (!isDuplicate) {
            uniqueHeader.push(element.header);
            return true;
          }

          return false;
        });

        const head = [];

        const newHeader = uniqueArray.map((el) => {
          return { ...el, header: el.alias ? el.alias : el.header, alias: el.alias ? '' : el.alias };
        });

        newHeader.forEach((el) => {
          head.push({ label: el.header });
        });

        setHeaders(head);
        setFetchedHeader(newHeader);
      } else {
        setHeaders([]);
        setFetchedHeader([]);
      }
      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField);
          setHeaderName(node.headerName);
          setConnectionType(node.formField.connection_type);
          setTempHeader(node.headerName);
          setFetchedHeader(node.fetchedHeader);
          setToggleType(node.toggleType);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
          // if (node.formField.connection_type === 'other' && node.formField.secret_name) {

          // }
          fetchSecrets();
        }
      });
    }
  };

  const validate = () => {
    if (formField.pathTypeFile === 'filepath' && !formField.path.includes('.csv')) {
      setErrors({ ...errors, filepath: 'Enter valid file path' });
    } else if (formField.pathTypeFile === 'outputpath' && formField.path.includes('.csv')) {
      setErrors({ ...errors, outputpath: 'Enter valid folder path' });
    } else {
      setErrors({ filepath: '', outputpath: '' });
    }
  };

  useEffect(() => {
    validate();
  }, [formField.path, errors.filepath, errors.outputpath]);

  useEffect(() => {
    setFormField(INITIALSTATE);
    setflowbuilderRowLevelOperation(RowLevelOperation);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    getLocalData();
  }, [nodeId]);

  const sendFormData = {
    nodeId,
    nodeName,
    formField,
    disabled: false,
    step_name: nodeName,
  };

  const filePath = connectionType === 'Default' ? output_path : output_path_secret;

  const refreshAllState = () => {
    handleRefreshModalOpen();

    let updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];

    let count = 0;

    setNodes((nds) =>
      nds.map((node) => {
        if (count <= updateNodes.length && node.id === updateNodes[count]) {
          node.position.x -= 0.1;
          count++;
        }

        return node;
      })
    );

    updateNodes = updateNodes.filter((el) => el !== nodeId);

    sessionStorage.setItem('updatedNodes', JSON.stringify(updateNodes));

    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (findSrcNodeId.length === 0) {
      setFormField(INITIALSTATE);
      setDisableForm(false);
      setFetchedHeader([]);
      setHeaderName([]);

      enqueueSnackbar('No source node is connected !!!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      handleRefreshModalClose();
      return;
    }

    let nodesExist = false;

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        nodesExist = true;
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            setPrevNodeName(node.step_name);
          }
        });
      });

      setFormField({ ...formField, df: prev_alias });
      const isHeader = header.some((item) => item.header);

      if (isHeader) {
        const newArr = [];

        if (prevNodeName === 'Join') {
          header.forEach((el) => {
            const exist = el.header.split('.').length;

            if (exist === 2) {
              const head = el.header.split('.')[1];
              newArr.push({ ...el, header: el.alias ? el.alias : head });
            }
          });
        }
        if (newArr.length > 0) {
          header = newArr;
        }

        const uniqueHeader = [];

        const uniqueArray = header.filter((element) => {
          const isDuplicate = uniqueHeader.includes(element.header);

          if (!isDuplicate) {
            uniqueHeader.push(element.header);
            return true;
          }

          return false;
        });

        const head = [];

        const newHeader = uniqueArray.map((el) => {
          return { ...el, header: el.alias ? el.alias : el.header, alias: el.alias ? '' : el.alias };
        });

        newHeader.forEach((el) => {
          head.push({ label: el.header });
        });

        setHeaders(head);

        if (nodesExist) {
          store.forEach((node) => {
            if (node.nodeId === nodeId) {
              setFormField(node.formField);
              setHeaderName(node.headerName);
              setToggleType(node.toggleType);

              const nonExistingHeader = [];
              node.fetchedHeader.forEach((item) => {
                const index = newHeader.findIndex((x) => x.header === item.header);

                if (index !== -1) {
                  nonExistingHeader.push(item);
                }
              });

              newHeader.forEach((el) => {
                const index = nonExistingHeader.findIndex((x) => x.header === el.header);

                if (index === -1) {
                  nonExistingHeader.push({
                    ...el,
                    header: el.alias ? el.alias : el.header,
                    alias: el.alias ? '' : el.alias,
                  });
                }
              });

              setFetchedHeader(nonExistingHeader);
            }
          });
        } else {
          setFetchedHeader(newHeader);
        }
      } else {
        setFetchedHeader([]);
      }
    }

    enqueueSnackbar('Data Refreshed!!!', {
      variant: 'Success',
      autoHideDuration: 3000,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
    handleRefreshModalClose();
  };

  let name, value;
  const handleInputChange = (e) => {
    name = e.target.name;
    value = e.target.value;

    if (name === 'alias') {
      setFormField({
        ...formField,
        [name]: value,
        path: `${
          // AWS_CONFIG_TYPE ? `${S3_BUCKET_NAME}` : 'dep-develop'
          'dep-develop'
        }/${client_name}/${engagement_name}/${workflow_name}/Output/${value}`,
      });
    } else {
      setFormField({
        ...formField,
        [name]: value,
      });
    }
  };

  const handleResetForm = () => {
    setFormField(INITIALSTATE);
  };

  useEffect(() => {
    if (store) {
      setTableName(
        store.map((node, i) => {
          if (node.nodeName !== 'WritePostgres') {
            return node.formField.alias;
          }
        })
      );
    }
  }, []);

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    // const regex = /^https:\/\//i;

    // if (toggleType === 'S3' && !regex.test(formField.path)) {
    //   enqueueSnackbar('S3 path is invalid!', {
    //     variant: 'error',
    //     autoHideDuration: 3000,
    //     anchorOrigin: { vertical: 'top', horizontal: 'right' },
    //   });
    //   return;
    // }

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    // let y_axis = 0;
    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        // y_axis = `${parseInt(el.position.y, 10)}`;
        el.data.label = formField.alias;
      }
    });

    const newHeaderName = [];

    // headerName.forEach((item) => {
    //   newHeaderName.push({ ...item, tableAlias: formField.alias });
    // });

    fetchedHeader.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField: {
        ...formField,
        index:
          formField.index.toLowerCase() ||
          `${workflow.engagement.client.client_name}_${workflow.engagement.engagement_name}_${workflow.workflow_name}`.toLowerCase(),
      },
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      fetchedHeader,
      toggleType,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    // if (!errors.stream_interval) {
    //   setDisableForm(true);
    // }
    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el['disabled'] = false;
      }
    });

    sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node'));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
  };

  const fetchSecrets = async () => {
    setLoadingBtn(true);
    try {
      const response = await getSecretsList('adls'); // Adjust if needed
      setSecretsList(response.data);
    } catch (error) {
      setLoadingBtn(false);
      enqueueSnackbar('Secrets not found!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
    setLoadingBtn(false);
  };

  const handleConnectionChange = (event) => {
    const connectionType = event.target.value; // Corrected variable name
    const newFilePath = connectionType === 'default' ? output_path : output_path_secret;
    setFormField((prevFormField) => ({
      ...prevFormField,
      tablename: '',
      connection_type: connectionType,
      secret_name: '', // Reset secret when changing connection type
      path: newFilePath,
    }));

    setFetchedHeader([]);
    setConnectionType(connectionType);
    setSelectedSecret('');

    if (connectionType === 'other') {
      fetchSecrets();
      // Fetch secrets when "Other" is selected
    }
  };

  const testSecret = async (secret) => {
    try {
      const payload = {
        secretName: secret,
        connectorType: 'adls',
      };
      const response = await testADLSSecretConnection(payload);
      if (response.status === 200) {
        return true;
      }
    } catch (error) {
      if (error.response.status === 403) {
        enqueueSnackbar(`You don't have Permission !!`, {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        enqueueSnackbar('Test Connection Failed', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
      return false;
    }
  };
  setLoadingBtn;

  const handleSecretSelection = async (secret) => {
    if (!testSecret(secret)) {
      return;
    }
    setFormField({
      ...formField,
      secret_name: secret, // Store selected secret
    });
    setFetchedHeader([]);
    setSelectedSecret(secret);
  };

  const handleChecked = (event) => {
    setFormField({ ...formField, sample_view: event.target.checked });
  };

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        // onClose={handleClose}
        TransitionComponent={Transition}
        style={{ width: '70%', marginLeft: '30%' }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: 'relative', backgroundColor: '#fff' }}>
            <Toolbar>
              <IconButton edge="start" onClick={handleClose} aria-label="close" sx={{ color: '#00043C' }}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: '#00043C' }} variant="h6" component="div">
                Write AZURE
              </Typography>
              <Tooltip title="Refresh Schema" placement="left">
                <IconButton
                  disabled={disableForm}
                  edge="start"
                  onClick={refreshAllState}
                  aria-label="close"
                  sx={{ color: '#00043C' }}
                >
                  <RotateLeftIcon />
                </IconButton>
              </Tooltip>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button size="small" variant="outlined" className="outlined-button-color" onClick={handleEdit}>
                  Edit
                </Button>
                <Button type="submit" size="small" variant="contained" disabled={disableForm} className="button-color">
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>

          <Box sx={{ p: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <InputField
                  name="data_set_id"
                  label="Data Set Id"
                  value={formField.p_key || `${workflow.workflow_name}_ds_${nodeId.split('_')[1]}`}
                  size="small"
                  disabled
                  required
                  style={{ width: '100%' }}
                />
              </Grid>
              <Grid item xs={4}>
                <InputField
                  name="alias"
                  label="Alias"
                  value={formField.alias}
                  onChange={handleInputChange}
                  size="small"
                  disabled={disableForm}
                  required
                  style={{ width: '100%' }}
                />
              </Grid>
              <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={formField.sample_view}
                      onChange={handleChecked}
                      disabled={disableForm}
                    />
                  }
                  label="Sample View"
                  sx={{ pt: 1 }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={4}>
                <TextField
                  id="outlined-select-currency"
                  select
                  label="Distinct Rows"
                  size="small"
                  value={formField.distinct_rows}
                  onChange={(event) => {
                    setFormField({
                      ...formField,
                      distinct_rows: event.target.value,
                    });
                  }}
                  disabled={disableForm}
                  fullWidth
                >
                  <MenuItem value="true">true</MenuItem>
                  <MenuItem value="false">false</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={4}>
                <TextField
                  select
                  name="df"
                  label="DF"
                  value={formField.df}
                  onChange={handleInputChange}
                  size="small"
                  disabled={disableForm}
                  required
                  fullWidth
                  InputProps={{
                    style: {
                      fontFamily: "'EB Garamond', serif ",
                      fontWeight: 600,
                    },
                  }}
                  InputLabelProps={{ style: { fontFamily: "'EB Garamond', serif " } }}
                >
                  {tableName.map((node, i) =>
                    node !== undefined ? (
                      <MenuItem value={node} key={i}>
                        {node}
                      </MenuItem>
                    ) : null
                  )}
                </TextField>
              </Grid>

              <Grid item xs={4}>
                <TextField
                  id="outlined-basic"
                  select
                  label="Mode"
                  variant="outlined"
                  value={formField.mode}
                  name="mode"
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  disabled={disableForm}
                  required
                >
                  <MenuItem value="overwrite">Overwrite</MenuItem>
                  <MenuItem value="append">Append</MenuItem>
                </TextField>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={4}>
                <TextField
                  id="outlined-basic"
                  select
                  label="Partition"
                  variant="outlined"
                  value={formField.partition}
                  name="partition"
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  disabled={disableForm}
                >
                  <MenuItem value>true</MenuItem>
                  <MenuItem value={false}>false</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  id="outlined-basic"
                  select
                  label="Persist"
                  variant="outlined"
                  value={formField.persist}
                  name="persist"
                  onChange={handleInputChange}
                  size="small"
                  disabled={disableForm}
                  fullWidth
                  InputProps={{
                    style: {
                      fontFamily: "'EB Garamond', serif ",
                      fontWeight: 600,
                    },
                  }}
                  InputLabelProps={{ style: { fontFamily: "'EB Garamond', serif " } }}
                >
                  <MenuItem value>true</MenuItem>
                  <MenuItem value={false}>false</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={4}>
                {formField.persist === true && (
                  <TextField
                    id="outlined-basic"
                    select
                    label="Persist Type"
                    variant="outlined"
                    value={formField.persist_type}
                    name="persist_type"
                    onChange={handleInputChange}
                    size="small"
                    disabled={disableForm}
                    fullWidth
                    InputProps={{
                      style: {
                        fontFamily: "'EB Garamond', serif ",
                        fontWeight: 600,
                      },
                    }}
                    InputLabelProps={{
                      style: { fontFamily: "'EB Garamond', serif " },
                    }}
                  >
                    <MenuItem value="DISK_ONLY">DISK_ONLY</MenuItem>
                    <MenuItem value="DISK_ONLY_2">DISK_ONLY_2</MenuItem>
                    <MenuItem value="MEMORY_ONLY">MEMORY_ONLY</MenuItem>
                    <MenuItem value="MEMORY_ONLY_2">MEMORY_ONLY_2</MenuItem>
                    <MenuItem value="MEMORY_AND_DISK">MEMORY_AND_DISK</MenuItem>
                    <MenuItem value="MEMORY_AND_DISK_2">MEMORY_AND_DISK_2</MenuItem>
                  </TextField>
                )}
              </Grid>
            </Grid>
          </Box>

          <Grid container spacing={2} sx={{ display: 'flex', ml: 1 }}>
            <Grid item xs={3.8}>
              <TextField
                id="outlined-basic"
                select
                label="Format"
                variant="outlined"
                value={formField.format}
                onChange={handleInputChange}
                name="format"
                size="small"
                fullWidth
                // sx={{ mt: 2 }}
                disabled={disableForm}
                InputProps={{
                  style: {
                    fontWeight: 600,
                  },
                }}
              >
                <MenuItem value="txt">txt</MenuItem>
                <MenuItem value="doc">doc</MenuItem>
                <MenuItem value="png">png</MenuItem>
                <MenuItem value="csv">csv</MenuItem>
                <MenuItem value="gif">gif</MenuItem>
                <MenuItem value="streaming">streaming</MenuItem>
                <MenuItem value="psv">psv</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={3.8}>
              <FormControl size="small" fullWidth>
                <InputLabel id="demo-select-small-label">Connection Type</InputLabel>
                {AWS_CONFIG_TYPE ? (
                  <Select
                    labelId="connection-type-label"
                    id="connection-type-select"
                    value={formField.connection_type}
                    label="Connection Type"
                    required
                    disabled={disableForm}
                    onChange={handleConnectionChange}
                  >
                    <MenuItem value="other">Other</MenuItem>
                  </Select>
                ) : (
                  <Select
                    labelId="connection-type-label"
                    id="connection-type-select"
                    value={formField.connection_type}
                    label="Connection Type"
                    required
                    disabled={disableForm}
                    onChange={handleConnectionChange}
                  >
                    <MenuItem value="default">Default</MenuItem>
                    <MenuItem value="other">Other</MenuItem>
                  </Select>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={3.8} sx={{ visibility: formField.connection_type === 'other' ? 'visible' : 'hidden' }}>
              <FormControl size="small" fullWidth>
                <InputLabel id="secrets-list-label">Select Connection</InputLabel>
                <Select
                  labelId="secrets-list-label"
                  id="secrets-list-select"
                  value={formField.secret_name}
                  label="Select Connection"
                  disabled={disableForm}
                  onChange={(e) => handleSecretSelection(e.target.value)}
                >
                  {secretsList.length > 0 ? (
                    secretsList.map((secret, index) => (
                      <MenuItem key={index} value={secret}>
                        {secret}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No Connection available</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ ml: 1, mt: 1 }}>
            <Grid item xs={10}>
              <FormControl
                sx={{
                  width: '100%',
                }}
              >
                <TextField
                  id="filepath"
                  name="path"
                  label="File Path"
                  value={formField.path}
                  onChange={handleInputChange}
                  size="small"
                  disabled
                  required
                  error={errors.filepath}
                  helperText={errors.filepath}
                />
              </FormControl>
            </Grid>
          </Grid>
        </form>
      </Dialog>
      <Modal open={refreshModalOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={styleLoading}>
          <LoadingIcon />
        </Box>
      </Modal>
    </>
  );
};

export default NodeModal_WriteAzure;
